{
    "type": {
        "new": "New",
        "unchanged": "Unchanged",
        "added": "Added",
        "removed": "Removed",
        "updated": "Updated"
    },
    "value": {
        "false": "No",
        "true": "Yes"
    },
    "placeholder": {
        "empty": "Empty",
        "truncated": "Truncated",
        "object": "Object"
    },
    "label": {
        "collapseAll": "Alt + click to collapse all",
        "expandAll": "Alt + click to expand all"
    }
}
